import { authHeaders, getBackendUrl } from "./http";

/** Tedarikciye gidecek DTF baski dosyasini indir: sifir kenarla kirpilmis,
 *  300 DPI, standart 11 inc / big print 16 inc. Sunucu dosya adini verir. */
export async function downloadPrintFile(designId: string, opts: { which?: "main" | "variant"; size?: "standard" | "big"; filename?: string } = {}): Promise<void> {
  // Sunucu dosyayi arka planda hazirlayip depoya yazar (hazir olana kadar 202), adresini dondurur;
  // indirmeyi tarayicinin indirme yoneticisi yapar. Tek uzun istekte 18 MB'yi fetch ile almak bazi
  // tarayicilarda "Failed to fetch" ile kopuyordu.
  const q = new URLSearchParams({ which: opts.which ?? "main", size: opts.size ?? "standard", as: "url" });
  type Res = { data?: { url?: string; filename?: string; pending?: boolean }; error?: string | { message?: string } } | null;
  let j: Res = null;
  for (let i = 0; i < 60; i++) {
    const res = await fetch(`${getBackendUrl()}/api/designs/${designId}/print-file?${q}`, { headers: authHeaders() });
    j = (await res.json().catch(() => null)) as Res;
    if (!res.ok) {
      const e = j?.error;
      throw new Error((typeof e === "string" ? e : e?.message) || `Baskı dosyası hazırlanamadı (${res.status})`);
    }
    if (j?.data?.url) break;
    await new Promise((r) => setTimeout(r, 2000));
  }
  if (!j?.data?.url) throw new Error("Baskı dosyası 2 dakikada hazırlanamadı; tekrar dene.");
  const { url, filename } = j.data as { url: string; filename?: string };
  const a = document.createElement("a");
  a.href = `${/^https?:/.test(url) ? url : `${getBackendUrl()}${url}`}?dl=${encodeURIComponent(filename || `${opts.filename ?? "tasarim"}.png`)}`;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
